export var APP_BAR_ITEM_TYPE;
(function (APP_BAR_ITEM_TYPE) {
    APP_BAR_ITEM_TYPE["fillSpace"] = "fillSpace";
    APP_BAR_ITEM_TYPE["link"] = "link";
    APP_BAR_ITEM_TYPE["separator"] = "separator";
    APP_BAR_ITEM_TYPE["custom"] = "custom";
})(APP_BAR_ITEM_TYPE || (APP_BAR_ITEM_TYPE = {}));
//# sourceMappingURL=AppBar.public.js.map